import type { CorrectionLevelFlag, CorrectionLevelInput } from '../types';

export function parseFlagString<T extends string>(
  raw: string | null | undefined,
  members: readonly T[],
): Set<T> {
  if (!raw) {
    return new Set();
  }

  const allowed = new Set<string>(members);
  return new Set(
    raw
      .split(',')
      .map((value) => value.trim())
      .filter((value): value is T => allowed.has(value)),
  );
}

export function stringifyFlagString<T extends string>(values: Iterable<T>): string {
  return [...values].join(', ');
}

export function correctionLevelToParam(
  value: CorrectionLevelInput | undefined,
  defaultValue?: CorrectionLevelInput,
  emptyFallback?: string,
): string | undefined {
  const resolved = value ?? defaultValue;
  if (resolved === undefined) {
    return emptyFallback;
  }
  return isCorrectionLevelFlags(resolved) ? stringifyFlagString(resolved) : resolved;
}

export function isCorrectionLevelFlags(
  value: CorrectionLevelInput | undefined,
): value is readonly CorrectionLevelFlag[] {
  return Array.isArray(value);
}
